import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import Edit from "@material-ui/icons/Edit";
import UserRoles from "../../constants/UserRoles";

export default class TimeOff extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Time_Off._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	fetchData = async (state) => {
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterRole = this.state.filterRole ?? null;
		this.state.filter.selfOnly = ![UserRoles.TORManager, UserRoles.Admin, UserRoles.Executive].includes(this.props.main_role);
		this.model.filter = this.state.filter;
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state);
		}, 100);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = [
			{
				Header: "Requested By",
				id: "usersrelatedbyrequestedfor.name_first",
				accessor: obj => obj.requested_by,
				minWidth: 100, // Set a minimal width
			},
			{
				Header: "Main Role",
				id: "main_role",
				accessor: obj => obj.users.main_role ? UserRoles[obj.users.main_role] : 'No Main Role',
				minWidth: 70,
			},
			{
				Header: "Requested Date",
				id: "requested_date_start",
				accessor: obj =>
					obj.requested_date_start === obj.requested_date_end
						? moment(obj.requested_date_start).local().format("MM/DD/YYYY")
						: moment(obj.requested_date_start).local().format("MM/DD/YYYY") +
						" - " +
						moment(obj.requested_date_end).local().format("MM/DD/YYYY"),
				minWidth: 100,
			},
			{
				Header: "Requested Time",
				id: "time_slots",
				accessor: obj => {
					if (obj.time_slots) {
						return obj.time_slots;
					}
					if (obj.full_day) {
						return "Full Day";
					}
					if (obj.users?.main_role === 40) {
						return "No slots selected";
					}
					return obj.full_day_am_pm ? "Half AM" : "Half PM";
				},
				minWidth: 100,
			},
			{
				Header: "Reason",
				id: "time_off_reasons.name",
				accessor: obj => obj.time_off_reasons.name,
				minWidth: 100,
			},
			{
				Header: "Submit Datetime",
				id: "created",
				accessor: obj =>
					moment(obj.created).tz('America/Phoenix').format('MM/DD/YYYY hh:mm'),
				minWidth: 150,
			},
			{
				Header: "Current Status",
				id: "time_off_status.status",
				accessor: obj => obj.time_off_status.status,
				minWidth: 100,
			},
			{
				Header: "Status Changed By",
				id: "status_changed_by_name",
				accessor: obj => obj.status_changed_by_name ?? "N/A",
				minWidth: 120,
			},
		];

		if (this.props.read_only) {
			columns.push({
				Header: "Additional Info",
				id: "notes",
				accessor: obj => obj.notes ?? "N/A",
				style: {
					whiteSpace: "normal", // Allow text to wrap
					wordWrap: "break-word",
				},
				minWidth: 200, // Allows the column to expand
			});
		} else {
			columns.push({
				Header: "",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<span>
							<Link to={"/schedule_adjust/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={"small"} />
								</Button>
							</Link>
						</span>
					);
				},
			});
		}

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Schedule Adjustments')}
							{this.props.main_role <= 21 && <ButtonGroup>
								<Button
									onClick={async () => {
										this.setState({filterRole: null}, () => this.fetchData())
									}}
									outline={this.state.filterRole}
									active={!this.state.filterRole}
									color={'primary'}
								>
									All
								</Button>
								<Button
									onClick={async () => {
										this.setState({filterRole: 30}, () => this.fetchData())
									}}
									outline={this.state.filterRole !== 30}
									active={this.state.filterRole === 30}
									color={'info'}
								>
									Dispatch
								</Button>
								<Button
									onClick={async () => {
										this.setState({filterRole: 40}, () => this.fetchData())
									}}
									outline={this.state.filterRole !== 40}
									active={this.state.filterRole === 40}
									color={'secondary'}
								>
									Engineer
								</Button>
							</ButtonGroup>}
							{this.renderHeaderRight("ScheduleAdjust", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
